import { useNavigate } from 'react-router-dom';
import { Button, Dialog } from './ui';

interface LoginPromptModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

/**
 * A reusable modal for prompting users to sign in to access features.
 * Navigates to /login when user confirms.
 */
export function LoginPromptModal({
  isOpen,
  onClose,
  title,
  message,
  confirmText = 'Sign In',
  cancelText = 'Maybe Later',
}: LoginPromptModalProps): React.JSX.Element | null {
  const navigate = useNavigate();

  const handleSignIn = (): void => {
    onClose();
    navigate('/login');
  };

  return (
    <Dialog isOpen={isOpen} onClose={onClose} title={title} size="md">
      <p className="text-gray-600 mb-6">{message}</p>
      <div className="flex justify-end gap-3">
        <Button onClick={onClose} variant="secondary">
          {cancelText}
        </Button>
        <Button onClick={handleSignIn} variant="primary">
          {confirmText}
        </Button>
      </div>
    </Dialog>
  );
}
